import {NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION, NO_SUCH_CUSTOMER_EXCEPTION} from '../../taskManagement/common/ExceptionsTypes'
import {Exceptions} from '../../common/constants'

export function copyCustomerRpcErrorHandler(rpcError) {
    rpcError.handleOnExceptions([
        NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION,
        NO_SUCH_CUSTOMER_EXCEPTION,
        Exceptions.NO_RIGHTS_FOR_REMOTE_CALL_EXCEPTION,
    ])
}



// WEBPACK FOOTER //
// ./web/js/panels/customer/utils.js